import Vue from 'vue'
import PrintDialog from './PrintDialog'

export const showPrintDialog = (propsData = {}) =>
  new Promise((resolve, reject) => {
    const Component = Vue.extend(PrintDialog)

    const instance = new Component({
      propsData,

      destroyed() {
        document.body.removeChild(this.$el)
      }
    }).$mount()

    document.body.appendChild(instance.$el)

    instance.$on('action', value => {
      resolve(value)
    })

    instance.$on('close', () => {
      resolve('close')
      reject()
    })
  })
